import { CLIENT } from '@/config';
import PATH from '@/routes/path';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ImgWithFallback from '../ImgWithFallback';

const CompanyLogo = ({ width, link, opacity = null }) => {
  const client = useSelector((state) => state.client);
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const rawUrl = client?.payload?.logo_url;
    if (!rawUrl) return;

    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      const calculatedHeight = width / aspectRatio;
      setImageSize({ width, height: calculatedHeight });
    };
    img.src = `${rawUrl}`;
  }, [client?.payload?.logo_url, width]);

  useEffect(() => {
    const rawDefault = client?.payload?.logo_url ? `${client.payload.logo_url}` : null;
    const rawLight = client?.payload?.logo_light_url ? `${client.payload.logo_light_url}` : null;

    setLogoUrl(opacity != null && opacity < 1 ? rawLight : rawDefault);
  }, [client?.payload?.logo_url, client?.payload?.logo_light_url, opacity]);

  if (!logoUrl) return null;

  const imgElement = (
    <ImgWithFallback
      src={logoUrl}
      sharpen={30}
      quality={100}
      ipxBase={CLIENT.IPX_BASE}
      alt="Company Logo"
      className="w-full h-full object-contain"
      style={{
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    />
  );

  return link ? (
    <Link to={PATH.HOME} style={imageSize} className="inline-flex items-center">
      {imgElement}
    </Link>
  ) : (
    <span style={imageSize} className="inline-flex items-center">
      {imgElement}
    </span>
  );
};

CompanyLogo.propTypes = {
  /** Lebar akhir image (px) untuk kalkulasi ratio */
  width: PropTypes.number,
  /** Jika true, logo dibungkus <Link> */
  link: PropTypes.bool,
  /** Jika <1, pakai `logo_light_url` */
  opacity: PropTypes.number,
};

CompanyLogo.defaultProps = {
  width: 140,
  link: false,
  opacity: null,
};

export default CompanyLogo;
